// src/i18n.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './zh.json'
import zhHK from './hk.json'
import vn from './vn.json'
import en from './en.json'
import th from './th.json'
import ja from './ja.json'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    zh: zhCN,
    hk: zhHK,
    vn: vn,
    en:zhCN,
    th:th,
    ja:ja
  }
})

export default i18n
